import React, { useRef } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

interface Person {
  name: string;
  role: string;
  photo?: string; // URL opcional. Deja vacío para mostrar iniciales.
  categories?: string[]; // solo para jurado
}

/* ---------------------------------------------------------------
   Comité organizador (Fundación NovaGob)
   --------------------------------------------------------------- */
const COMMITTEE: Person[] = [
  {
    name: 'Máximo Fraile',
    role: 'Vicepresidente Fundación NovaGob',
    photo: 'https://novagob.org/wp-content/uploads/2024/02/DSC00361-scaled.jpg',
  },
  {
    name: 'Cristina Galíndez',
    role: 'Directora ejecutiva Fundación NovaGob México',
    photo: 'https://novagob.org/wp-content/uploads/2023/12/DSC00220-scaled.webp',
  },
  {
    name: 'Loredana Stan',
    role: 'Directora Fundación NovaGob',
    photo: 'https://novagob.org/wp-content/uploads/2025/11/DSC02226-scaled.jpg',
  },
];

/* ---------------------------------------------------------------
   Jurado de la edición 2026
   --------------------------------------------------------------- */
const JURY_2025: Person[] = [
  {
    name: 'Ylenia Díaz',
    role: 'Secretaria General del Ayuntamiento de Riba-roja de Túria',
    photo: '/img_jurado/YleniaDiaz.jpg',
    categories: ['Persona innovadora del año'],
  },
  {
    name: 'Tania Gullón',
    role: 'Directora de la División de Estudios y Tecnología del Transporte · Ministerio de Transportes y Movilidad Sostenible',
    photo: '/img_jurado/TaniaGullon.jpeg',
    categories: ['Persona innovadora del año', 'Mujer Destacada del Sector Público'],
  },
  {
    name: 'Paula Daniela Fernández Lopes',
    role: 'Secretaría de Innovación, Ciencia y Tecnología · Jefatura de Gabinete de Ministros de Argentina',
    photo: '/img_jurado/PaulaDaniela.jpeg',
    categories: ['Nuevo talento público', 'Proyecto Innovador LATAM'],
  },
  {
    name: 'Lorena Estruch Martínez',
    role: 'Responsable de Prevención de Riesgos Laborales, Calidad e Innovación · Ayuntamiento de Dénia',
    photo: '/img_jurado/LorenaEstruch.jpeg',
    categories: ['Persona Innovadora LATAM'],
  },
  {
    name: 'Eva María García Camaño',
    role: 'Directora de la Oficina de Mediación · Ayuntamiento de Madrid',
    photo: '/img_jurado/EvaMariaGarciaCamano.jpeg',
    categories: ['Buen gobierno'],
  },
  {
    name: 'Matilde Castellanos',
    role: 'Viceinterventora General de la Intervención General · Junta de Comunidades de Castilla-La Mancha',
    photo: '/img_jurado/MatildeCastellanos.jpeg',
    categories: ['Proyecto más transformador', 'Buen gobierno'],
  },
  {
    name: 'Josean Latorre',
    role: 'Experto en Innovación y Aprendizaje',
    photo:
      'https://novagob.org/wp-content/uploads/2024/02/jose-antonio-latorre-jurado.png',
    categories: ['Persona innovadora del año', 'Nuevo talento público'],
  },
  {
    name: 'Leonor Torres',
    role: 'Presidenta de ASTIC · Jefa de Servicio en Informática, Ayuntamiento de Madrid',
    photo: 'https://novagob.org/wp-content/uploads/2023/07/leonor.jpg',
    categories: ['Mujer Destacada del Sector Público', 'Transformación digital'],
  },
  {
    name: 'Óscar Cortés',
    role: 'Coordinador de Comunicación Digital · Ayuntamiento de Madrid',
    photo: '/img_jurado/OscarCortes.png',
    categories: ['Mujer Destacada del Sector Público'],
  },
  {
    name: 'José Joaquín de Haro',
    role: 'Jefe de Servicio de Modernización Administrativa y TIC · Diputación de Albacete',
    photo: '/img_jurado/JoseJoaquinDeHaro.jpg',
    categories: [
      'Proyecto que haya generado mayor eficiencia',
      'Transformación digital',
    ],
  },
  {
    name: 'Ana Báez',
    role: 'Experta en Innovación y Liderazgo Femenino',
    photo: '/img_jurado/AnaBaez.jpg',
    categories: ['Nuevo talento público', 'Creatividad en la innovación'],
  },
  {
    name: 'Roberto Magro',
    role: 'Subdirector General de Juventud · Ayuntamiento de Alcobendas',
    photo: '/img_jurado/RobertoMagro.jpeg',
    categories: ['Transformación digital', 'Buen gobierno'],
  },
  {
    name: 'Maite Covisa',
    role: 'Consultora de Servicios · Dirección General de Modernización, Gobierno de Canarias',
    photo: '/img_jurado/MaiteCovisa.jpeg',
    categories: ['Proyecto más transformador', 'Gestión de personas en las administraciones públicas'],
  },
  {
    name: 'Rita Grandinetti',
    role: 'Directora PoliLab · Universidad Nacional de Rosario',
    photo: '/img_jurado/RitaGrandinetti.jpeg',
    categories: ['Proyecto que haya generado mayor eficiencia', 'Persona Innovadora LATAM'],
  },
  {
    name: 'Ana Caro',
    role: 'Directora de coordinación de proyectos · Universidad Autónoma de Madrid',
    photo: 'https://novagob.org/wp-content/uploads/2025/03/AnaCaro.jpeg',
    categories: [
      'Proyecto que haya generado mayor eficiencia',
      'Gestión de personas en las administraciones públicas',
    ],
  },
  {
    name: 'Manuel Serrano',
    role: 'Ex responsable de Calidad y Modernización (emérito) · Ayuntamiento de Málaga',
    photo: '/img_jurado/ManuelSerrano.jpg',
    categories: ['Creatividad en la innovación', 'Proyecto más transformador'],
  },
  {
    name: 'Manuel Pérez Gómez',
    role: 'Viceconsejero de Digitalización · Comunidad de Madrid',
    photo: '/img_jurado/ManuelPerezGomez.jpeg',
    categories: ['Creatividad en la innovación'],
  },
  {
    name: 'Ernesto Velasco',
    role: '',
    photo: 'https://novagob.org/wp-content/uploads/2023/06/IMG-20230616-WA0018.jpg',
    categories: ['Persona Innovadora LATAM'],
  },
  {
    name: 'Antonio Díaz Méndez',
    role: '',
    photo: '/img_jurado/AntonioDiazMendez.jpeg',
    categories: ['Proyecto Innovador LATAM'],
  },
  {
    name: 'Allison Quesada',
    role: '',
    photo: '/img_jurado/AllisonQuesada.jpeg',
    categories: ['Proyecto Innovador LATAM'],
  },
];

const getInitials = (name: string) =>
  name
    .split(' ')
    .filter((w) => w.length > 0)
    .slice(0, 2)
    .map((w) => w[0]?.toUpperCase() ?? '')
    .join('');

interface PersonCardProps {
  person: Person;
  large?: boolean;
}

const PersonCard: React.FC<PersonCardProps> = ({ person, large }) => (
  <article className={`cj-card${large ? ' cj-card-large' : ''}`}>
    <div className="cj-photo">
      {person.photo ? (
        <img src={person.photo} alt={person.name} />
      ) : (
        <span className="cj-photo-initials">{getInitials(person.name)}</span>
      )}
    </div>
    <h4 className="cj-name">{person.name}</h4>
    <p className="cj-role">{person.role}</p>
    {person.categories && person.categories.length > 0 && (
      <>
        <span className="cj-categories-label">
          Categoría{person.categories.length > 1 ? 's' : ''}
        </span>
        <div className="cj-categories">
          {person.categories.map((c) => (
            <span key={c} className="cj-category-chip">
              {c}
            </span>
          ))}
        </div>
      </>
    )}
  </article>
);

const CommitteeJurySection: React.FC = () => {
  const trackRef = useRef<HTMLDivElement>(null);

  const scrollByOne = (dir: 1 | -1) => {
    const track = trackRef.current;
    if (!track) return;
    const firstSlide = track.firstElementChild as HTMLElement | null;
    if (!firstSlide) return;
    // El ancho del slide + gap (16px). Desplazamos exactamente un slide.
    const delta = firstSlide.clientWidth + 16;

    const { scrollLeft, scrollWidth, clientWidth } = track;
    // Umbral de 2px de tolerancia para posiciones límite.
    const atStart = scrollLeft <= 2;
    const atEnd = scrollLeft + clientWidth >= scrollWidth - 2;

    if (dir === 1 && atEnd) {
      // Final alcanzado → volver al principio
      track.scrollTo({ left: 0, behavior: 'smooth' });
    } else if (dir === -1 && atStart) {
      // Principio → saltar al final
      track.scrollTo({ left: scrollWidth, behavior: 'smooth' });
    } else {
      track.scrollBy({ left: dir * delta, behavior: 'smooth' });
    }
  };

  return (
    <section id="comite-jurado" className="landing-section landing-cj">
      <div className="landing-container">
        <h2 className="landing-section-title text-gold-shine">Comité y Jurado</h2>
        <p className="landing-section-lead">
          Las personas que organizan e interpretan las bases y evalúan las
          candidaturas.
        </p>

        <div className="cj-subsection">
          <h3 className="cj-subtitle">Comité organizador</h3>
          <div className="cj-grid cj-grid-committee">
            {COMMITTEE.map((p) => (
              <PersonCard key={p.name} person={p} large />
            ))}
          </div>
        </div>

        <div className="cj-subsection">
          <div className="cj-subsection-header">
            <h3 className="cj-subtitle">Jurado de la edición 2026</h3>
            <div className="cj-carousel-controls">
              <button
                type="button"
                className="cj-arrow"
                onClick={() => scrollByOne(-1)}
                aria-label="Miembro anterior"
              >
                <ChevronLeft size={20} />
              </button>
              <button
                type="button"
                className="cj-arrow"
                onClick={() => scrollByOne(1)}
                aria-label="Siguiente miembro"
              >
                <ChevronRight size={20} />
              </button>
            </div>
          </div>

          <div className="cj-jury-carousel">
            <div className="cj-jury-track" ref={trackRef}>
              {JURY_2025.map((p) => (
                <div key={p.name} className="cj-jury-slide">
                  <PersonCard person={p} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CommitteeJurySection;
